import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { assets, contactEmail } from '../../data/assets';
import { legalLinks, navLinks } from '../../data/navigation';
import { SocialLinks } from '../SocialLinks';
import { TextRoll } from '../TextRoll';
interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}
const itemMotion = {
  hidden: {
    x: -50,
    opacity: 0
  },
  show: (i: number) => ({
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      delay: 0.05 + i * 0.1,
      ease: [0.23, 1, 0.32, 1]
    }
  })
};
export function MobileMenu({
  open,
  onClose
}: MobileMenuProps) {
  const year = new Date().getFullYear();
  const extrasStart = navLinks.length;
  return <AnimatePresence data-id="element-3" data-mp="1mdo762fkbqan">
      {open && <motion.div id="mobile-menu" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-0 z-30 overflow-y-auto bg-black text-white lg:hidden" data-id="element-4" data-mp="1mepk6cg52mv0">
          <motion.img src={assets.navBg} alt="" initial={{
        scale: 1.4,
        opacity: 0.5
      }} animate={{
        scale: 1,
        opacity: 0.2
      }} transition={{
        duration: 2,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-none absolute inset-0 h-full w-full object-cover" data-id="element-5" data-mp="1a2f5gfx1z77i" />
          <div className="relative flex min-h-[100dvh] flex-col justify-between gap-12 px-5 pb-10 pt-[20vh] md:px-10" data-id="element-6" data-mp="r55jar0cffmk">
            <nav aria-label="Mobile" data-id="element-7" data-mp="m7426bmh9qdq">
              <ul className="flex flex-col items-start gap-6" data-id="element-8" data-mp="m85e0ibbigwi">
                {navLinks.map((link, i) => <motion.li key={link.label} custom={i} variants={itemMotion} initial="hidden" animate="show" data-id="element-9" data-mp="103zdkaq7btwy" data-mpi={i}>
                    <a href={link.href} onClick={onClose} className="roll-link block text-[2rem] font-normal leading-none tracking-[0.5px]" data-id="element-10" data-mp="w6uty5jnlra4">
                      <TextRoll label={link.label} data-id="element-11" data-mp="1499k6am4nvxd" />
                    </a>
                  </motion.li>)}
              </ul>
            </nav>

            <div className="flex flex-col gap-12" data-id="element-12" data-mp="199xep69keuwc">
              <motion.div custom={extrasStart} variants={itemMotion} initial="hidden" animate="show" className="flex flex-col gap-[1.125rem]" data-id="element-13" data-mp="1e7yzpwqjx4ag">
                <p className="text-[0.875rem] font-medium tracking-[0.01em]" data-id="element-14" data-mp="1i6eskh9bd6vs">Business email</p>
                <a href={`mailto:${contactEmail}`} className="im-underline im-underline-light relative self-start text-[1.56rem] font-normal leading-none tracking-[0.5px] sm:text-[1.25rem]" data-id="element-15" data-mp="lg5l29q54qvd">
                  {contactEmail}
                </a>
              </motion.div>

              <motion.div custom={extrasStart + 1} variants={itemMotion} initial="hidden" animate="show" className="flex flex-col gap-[1.125rem]" data-id="element-16" data-mp="2rqx5vb4dsys">
                <p className="text-[0.875rem] font-medium tracking-[0.01em]" data-id="element-17" data-mp="6s19dppi9fm3">Follow us on</p>
                <SocialLinks variant="menu" data-id="element-18" data-mp="3vdxpba2qwyfv" />
              </motion.div>

              <motion.div custom={extrasStart + 2} variants={itemMotion} initial="hidden" animate="show" className="flex flex-wrap gap-x-4 gap-y-[0.63em]" data-id="element-19" data-mp="3qfmh13s3mvzr">
                {legalLinks.map(link => <a key={link.label} href={link.href} className="text-[0.813rem] font-normal tracking-[0.01em] text-white/50 transition-colors duration-200 hover:text-white sm:text-[0.875rem]" data-id="element-20" data-mp="3hfzfmhzddq6p">
                    {link.label}
                  </a>)}
                <p className="w-full text-[0.813rem] font-normal tracking-[0.01em] text-white/50 sm:text-[0.875rem]" data-id="element-21" data-mp="32qteupkvvrwp">
                  Immersive Studios © {year}
                </p>
              </motion.div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}